module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../hyperdb-utils/~/babel-runtime/core-js/object/assign.js
// module id = 310
// module chunks = 0